import React from 'react';
import GruShell from '../../components/gru/GruShell';
import GruHomeContent from './components/GruHomeContent';

// /gru-inventory — home del modulo GRU (carriponti)
const GruHomePage = () => (
  <GruShell indietroA="/acv-home">
    <GruHomeContent />
  </GruShell>
);

export default GruHomePage;
